import React from 'react';
import { Divider, Paper, Stack } from '@mui/material';

export interface StatStripProps {
  children: React.ReactNode;
}

/**
 * Horizontal strip of {@link StatCard}s separated by subtle
 * vertical dividers. Layout references StateSpin's Articles page
 * (spec §3.3): Matching / Timeframe / Search / Filters.
 */
export const StatStrip: React.FC<StatStripProps> = ({ children }) => {
  return (
    <Paper
      variant="outlined"
      sx={{
        px: 2,
        py: 1,
        display: 'inline-flex',
      }}
    >
      <Stack
        direction="row"
        divider={
          <Divider orientation="vertical" flexItem sx={{ my: 1 }} />
        }
        spacing={2}
        alignItems="stretch"
      >
        {children}
      </Stack>
    </Paper>
  );
};

export default StatStrip;
